import { ReactNode } from 'react';

import CheckBox, { CheckboxProps } from '@mui/material/Checkbox';

import { FormControl, FormControlLabel } from '../form/form';
import { useTheme } from '../styles/styles';
import Checkbox from './checkbox';

type CheckboxFieldProps = CheckboxProps & {
  name?: string;
  fullWidth?: boolean;
  label: ReactNode;
  disabled?: boolean | false;
  updatedStyling?: boolean;
};

const CheckboxField = ({
  size = 'small',
  fullWidth,
  required,
  name,
  label,
  value,
  checked,
  onChange,
  onBlur,
  disabled,
  updatedStyling,
}: CheckboxFieldProps) => {
  const theme = useTheme();
  return (
    <FormControl required={required} fullWidth={fullWidth} size={size as any}>
      <FormControlLabel
        sx={{
          borderRadius: '10px',
          ...(updatedStyling && {
            backgroundColor: theme.background.lightGrey2,
            height: '44px',
            width: '100%',
            alignSelf: 'center',
          }),
        }}
        label={label}
        control={
          <Checkbox
            updatedStyling={updatedStyling}
            name={name}
            value={value}
            size={size}
            checked={checked}
            onChange={onChange}
            onBlur={onBlur}
            disabled={disabled}
          />
        }
      />
    </FormControl>
  );
};

export type { CheckboxProps };
export { CheckBox, CheckboxField };
